/**
 * AxonometricOnboarding — content for the Axonometric mode onboarding panel.
 *
 * Pure presentational component: renders the title, body and CTA.
 * Visibility and sessionStorage persistence are handled by OnboardingContext /
 * OnboardingOverlay — this component only renders the content slot.
 */
import { useState } from 'react';

import { useI18n } from '../../../../shared/i18n/useI18n.js';

import {
	AxonometricMode,
	CompassNorth,
	RotateLeft,
	RotateRight,
	Swipe,
} from '../../../../shared/ui/icons/index.js';

import styles from './AxonometricOnboarding.module.scss';
import pane_styles from './OnboardingOverlay.module.scss'; // for shared styles like .title

export function AxonometricOnboarding({ isMobile, loadExpanded = false }) {
	const { t } = useI18n();
	const [expanded, setExpanded] = useState(loadExpanded);

	return (
		<div className={pane_styles.content}>
			<span className={pane_styles.title}>
				<AxonometricMode />
				{t('product.axonometric_onboarding_title')}
			</span>
			{expanded && (
				<p className={pane_styles.body}>
					{t('product.axonometric_onboarding_par1')}
				</p>
			)}
			<p className={styles.cta}>
        <span className={styles.iconsContainer}>
          <Swipe width="3em" height="3em" />
        </span>
				{t('product.axonometric_onboarding_cta')}
			</p>
			{expanded && (
				<>
					<p className={styles.instruction}>
						<span className={styles.iconsContainer}>
							<RotateLeft width="2em" height="2em" />
							<RotateRight width="2em" height="2em" />
						</span>
						{t('product.axonometric_onboarding_par2')}
					</p>
					<p className={styles.instruction}>
						<span className={styles.iconsContainer}>
							<CompassNorth width="2em" height="2em" />
						</span>
						{t('product.axonometric_onboarding_par3')}
					</p>
				</>
			)}
			<span
				className={pane_styles.cta}
				onClick={() => setExpanded((e) => !e)}
				style={{ cursor: 'pointer' }}
			>
				{expanded
					? t('product.onboarding_hide_details')
					: t('product.onboarding_learn_more')}
			</span>
		</div>
	);
}
